import { lazy } from 'react';

export const LazyTemplatesPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--templates-page" */ './templates-page'
    ),
);
